import React from 'react';
import { Container, Paper, Typography, Box, Alert } from '@mui/material';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import LoginForm from '../components/auth/LoginForm';

/**
 * Pop the saved deep-link destination that ProtectedRoute stashed before
 * bouncing the user to /login. Safe-guard against auth-loop targets.
 */
const consumeReturnTo = () => {
  try {
    const v = sessionStorage.getItem('automatrix.returnTo');
    if (!v) return '/';
    sessionStorage.removeItem('automatrix.returnTo');
    if (v.startsWith('/login') || v.startsWith('/auth/')) return '/';
    return v;
  } catch (e) {
    return '/';
  }
};

const LoginPage = () => {
  const { isAuthenticated, loading, error } = useSelector(state => state.auth);

  if (isAuthenticated && !loading) {
    return <Navigate to={consumeReturnTo()} replace />;
  }

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8, mb: 4 }}>
        <Typography variant="h4" component="h1" align="center" gutterBottom>
          Welcome to Automatrix
        </Typography>
        <Typography variant="body1" align="center" color="text.secondary" paragraph>
          The intelligent web automation platform
        </Typography>
      </Box>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
        <LoginForm />
      </Paper>
    </Container>
  );
};

export default LoginPage;
